export enum AllaganReportStatus {
  PROPOSAL = 'PROPOSAL',
  MODIFICATION = 'MODIFICATION',
  DELETION = 'DELETION',
  ACCEPTED = 'ACCEPTED',
}
